import { ContentTopInfoBox } from './content/top-info-box';
import { InternImage } from './intern/image';
import { InternSubline } from './intern/subline';
import { LinkActionLink } from './link/action-link';
import { LinkAssetLink } from './link/asset-link';
import { LinkExternalLink } from './link/external-link';
import { LinkInternalLink } from './link/internal-link';
import { LinkThematischerLink } from './link/thematischer-link';
import { Tag } from './tag';

/**
 * Model definition for product-card
 */
export interface ProductCard {
  __contentType: 'product-card';
  id: string;
  name?: string;
  displayTags?: boolean;
  subline?: InternSubline;
  teaserText?: string;
  media?: InternImage;
  link?: [LinkExternalLink | LinkInternalLink | LinkThematischerLink | LinkActionLink | LinkAssetLink];
  benefits?: ContentTopInfoBox;
  tags?: Tag[];
}

export function isProductCard(obj: { __contentType?: string }): obj is ProductCard {
  return obj.__contentType === 'product-card';
}
